// dna_frontend/src/pages/AdminUpdateNamSinh.js
// (Copy và thay thế toàn bộ file)

import React, { useState } from 'react';
import api from '../services/api';
import {
  Container, Typography, Paper, Box, Button,
  CircularProgress, Alert, AlertTitle
} from '@mui/material';

function AdminUpdateNamSinh() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setError(null);
    setSuccess(null);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      setError({ message: 'Vui lòng chọn một file Excel.' });
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(null);
    
    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await api.post('/than-nhan/admin/update-nam-sinh-bulk', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setSuccess(res.data);
      setFile(null); // Xóa file đã chọn
      document.getElementById('file-upload-input').value = null; // Reset input
    } catch (err) {
      setError(err.response?.data || { message: 'Lỗi không xác định' });
    } finally {
      setLoading(false);
    }
  };

  const renderErrorDetails = () => {
    if (!error) return null;
    return (
      <Alert severity="error" sx={{ mt: 2 }}>
        <AlertTitle>Lỗi khi xử lý file</AlertTitle>
        {error.message}
        {error.errors && error.errors.length > 0 && (
          <ul style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {error.errors.map((err, i) => (<li key={i}>{err}</li>))}
          </ul>
        )}
        {error.duplicates && error.duplicates.length > 0 && (
          <>
            <strong>Lỗi trùng lặp (Đã hủy toàn bộ):</strong>
            <ul style={{ maxHeight: '200px', overflowY: 'auto' }}>
                {error.duplicates.map((err, i) => (<li key={i}>{err}</li>))}
            </ul>
          </>
        )}
      </Alert>
    );
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        Bổ sung Năm sinh Hàng loạt
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body1" gutterBottom>
          Chức năng này dùng để cập nhật năm sinh hàng loạt cho các thân nhân bị thiếu.
        </Typography>
        <Typography variant="body2" component="div" gutterBottom>
          File Excel phải có 2 cột chính xác:
          <ul>
            <li>Cột <strong>id</strong> (chứa ID của thân nhân trong CSDL)</li>
            <li>Cột <strong>nam_sinh</strong> (chứa năm sinh gồm 4 chữ số, ví dụ: 1950)</li>
          </ul>
        </Typography>
        
        <Box component="form" onSubmit={handleUpload} sx={{ mt: 2 }}>
          <input 
            type="file" 
            id="file-upload-input" 
            onChange={handleFileChange} 
            accept=".xlsx, .xls" 
          />
          <Button 
            type="submit" 
            variant="contained" 
            disabled={loading || !file}
            sx={{ ml: 2 }}
          >
            {loading ? <CircularProgress size={24} /> : 'Upload và Cập nhật'}
          </Button>
        </Box>
      </Paper>
      
      {success && (
        <Alert severity="success" sx={{ mt: 2 }}>
          <AlertTitle>Thành công</AlertTitle>
          {success.message}
        </Alert>
      )}
      
      {renderErrorDetails()}
    </Container>
  );
}

export default AdminUpdateNamSinh;